<section class="browser-dimensions">
  <mat-icon>aspect_ratio</mat-icon>
  <div i18n="@@browserDimensions">page2flip is not compatible with this window size. Please change the window size.</div>
</section>
